import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import AppStack from "./AppStack";
import AuthStack from "./AuthStack";
import ErrorPage from "../component/views/ErrorPage";
import Blank from "../screens/Blank";
import EditProfile from "../screens/EditProfile";
import { DashboardView } from "../screens/DashboardView/list";
import FirstLoginStack from "./FirstLoginStack";
import { UserRole } from "../constants/enum/UserRole";
import { useEffect } from "react";
import { STUDENT_REDIRECT } from "../constants/consts";
import { authSlice } from "../services/stores/auth/slice";
import { useDispatch, useSelector } from "react-redux";

//*screens from UnitView
import { UnitView } from "../screens/UnitView/list";
import { UnitForm } from "../screens/UnitView/form";
import { UnitViewDetails } from "../screens/UnitView/view/index";

//*screens from UsersStudentView
import { UsersStudentView } from "../screens/UsersStudentView/list/index";
import { UsersStudentForm } from "../screens/UsersStudentView/form/index";

//*screens from CourseView
import { CourseView } from "../screens/CourseView/list";
import { CourseForm } from "../screens/CourseView/form";
import { CourseViewDetails } from "../screens/CourseView/view";

//*screens from OrganizationView
import { OrganizationView } from "../screens/OrganizationView/list/index";
import { OrganizationForm } from "../screens/OrganizationView/form/index";

//*screens from UsersAdminView
import { UsersAdminView } from "../screens/UsersAdminView/list/index";
import { UsersAdminForm } from "../screens/UsersAdminView/form/index";

//*screens from ClassView
import { ClassView } from "../screens/ClassView/list/index";
import { ClassForm } from "../screens/ClassView/form/index";
import { ClassManager } from "../screens/ClassView/view/index";

//*screens from TagsView
import { TagsView } from "../screens/TagView/list/index";
import { TagsForm } from "../screens/TagView/form/index";

//*screens from UsersTeacherView
import { UsersTeacherView } from "../screens/UsersTeacherView/list/index";
import { UsersTeacherForm } from "../screens/UsersTeacherView/form/index";

//*screens from UsersColaboratorView
import { UsersCollaboratorView } from "../screens/UsersCollaboratorView/list/index";
import { UsersCollaboratorForm } from "../screens/UsersCollaboratorView/form/index";

//*screens from RegistrationView
import { RegistrationView } from "../screens/RegistrationView/list/index";
import { RegistrationForm } from "../screens/RegistrationView/form/index";

//*screens from PermissionsView
import { PermessionForm } from "../screens/PermissionView/index";

//*screens from TestsView
import { ExamView } from "../screens/ExamView/list/index";
import { ExamForm } from "../screens/ExamView/form/index";

//*screens from QuestionView
import { QuestionsView } from "../screens/QuestionsView/list";
import { QuestionsForm } from "../screens/QuestionsView/form";

//*screens from QuestionPublicView
import { QuestionsPublicView } from "../screens/QuestionsPublicView";
import { QuestionsPublicEdit } from "../screens/QuestionsPublicView/QuestionsPublicEdit";

//*screens from Unauthorized
import Unauthorized from "../screens/Unauthorized/Unauthorized";

//!Unauthorized
import ProtectedRoute from "../component/security/ProtectedRoute";

//*screens from DisciplinesView
import { DisciplinesView } from "../screens/DisciplineView/list/index";
import { DisciplinesForm } from "../screens/DisciplineView/form/index";

//*screens from ApplicationView
import { ApplicationView } from "../screens/ApplicationView/list/index";
import { ApplicationForm } from "../screens/ApplicationView/form/index";
import { ApplicationManagerView } from "../screens/ApplicationView/manager/index";
import { ApplicationManagerFormStudent } from "../screens/ApplicationView/manegerForm/students/index";
import { ApplicationManagerFormReviewers } from "../screens/ApplicationView/manegerForm/reviewers/index";
import { ApplicationManagerExamForm } from "../screens/ApplicationView/manegerForm/test/index";
import { ApplicationManagerDiagramForm } from "../screens/ApplicationView/manegerForm/diagrams/index";
import { AnswerSheets } from "../screens/ApplicationView/printingDiagram/form";

//*screens from DemandsView
import { DemandsView } from "../screens/DemandView/list/index"; 
import { DemandForm } from "../screens/DemandView/form/index";
import { DemandsManagerView } from "../screens/DemandView/manager/index";
import { DemandsManagerForm } from "../screens/DemandView/managerForm/index";
import { QuestionsDemandForm } from "../screens/QuestionsView/demand/index";

//*screens from LayoutsExamsView
import { DiagramView } from "../screens/LayoutsExamsView/list/index";
import CriarDiagramacao from "../screens/LayoutsExamsView/form3/index";

//* Importamos a tela de trocar a senha
import { ChangePasswordFirstLoginView } from "../screens/LoginView/change-password/index";
import { Usabilidade } from "../screens/Usabilidade/list";
import { Manutenibilidade } from "../screens/Manutenibilidade/list";
import { Avaliacao } from "../screens/Usabilidade/avaliacao";
import { Visibilidade } from "../screens/Usabilidade/visibilidade";
import { Correspondecia } from "../screens/Usabilidade/correspondecia";
import { Controle } from "../screens/Usabilidade/controle";
import { Consistencia } from "../screens/Usabilidade/consistencia";
import { Prevencao } from "../screens/Usabilidade/prevencao";
import { Reconhecimento } from "../screens/Usabilidade/reconhecimento";
import { Flexibilidade } from "../screens/Usabilidade/flexibilidade";
import { Design } from "../screens/Usabilidade/design";
import { Ajuda } from "../screens/Usabilidade/ajuda";
import { Documentacao } from "../screens/Usabilidade/documentacao";
import { Gestao } from "../screens/Usabilidade/gestao";
import { Uso } from "../screens/Usabilidade/uso";
import { Visualizacao } from "../screens/Usabilidade/visualizacao";
import { Adaptabilidade } from "../screens/Usabilidade/adaptabilidade";
import { Apresentacao } from "../screens/Usabilidade/apresentacao";

import { AvaliacaoM } from "../screens/Manutenibilidade/avaliacaoM";
import { Modularidade } from "../screens/Manutenibilidade/modularidade";
import { Documentalidade } from "../screens/Manutenibilidade/documentalidade";
import { Disponibilidade } from "../screens/Manutenibilidade/disponibilidade";
import { Modificabilidade } from "../screens/Manutenibilidade/modificabilidade";
import { Testabilidade } from "../screens/Manutenibilidade/testabilidade";
import { Legibilidade } from "../screens/Manutenibilidade/legibilidade";
import ModalMensagem from "../component/base/ModalMensagem";

export const { logout } = authSlice.actions;

export function RedirectPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      window.location.replace(STUDENT_REDIRECT as string);
      return dispatch(logout(""));
    }, 5000);
  }, []);
  return (
    <p
      style={{
        margin: "0px 0px 0.35em",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "2.125rem",
        lineHeight: 1.235,
        letterSpacing: "0.00735em",
        fontWeight: 700,
        textAlign: "center",
      }}
    >
      <br />
      <br />
      Essa plataforma é para uso exclusivo de professores e colaboradores da
      instituição.
      <br />
      <br />
      Você será redirecionado para a área do aluno.
    </p>
  );
}

export default function AppNav() {
  const { logged, blank, status, me } = useSelector((store: any) => store.auth);

  /**
   * Observação:
   * - isPasswordDefinitive: boolean que indica se a senha do usuário é definitiva ou não.
   * - skipPasswordChange: boolean que indica se o usuário já pulou a troca de senha (para não mostrar novamente).
   */

  function Root() {
    return blank === true ? (
      <>
        <Outlet />
      </>
    ) : logged === undefined ? (
      <></>
    ) : logged === true ? (
      // Se o status do usuário for CREATED, ainda mostramos o FirstLoginStack
      status === "CREATED" || !status ? (
        <FirstLoginStack />
      ) : // SE senha não é definitiva E usuário NÃO pulou a troca => tela de troca
      !me.isPasswordDefinitive && !me.skipPasswordChange ? (
        <ChangePasswordFirstLoginView />
      ) : // Caso seja student
      me.role?.slug === UserRole.STUDENT_USER ? (
        <RedirectPage />
      ) : (
        // Caso nenhum dos acima, vai pro AppStack
        <AppStack />
      )
    ) : (
      // Se não está logado, exibe o AuthStack
      <AuthStack />
    );
  }

  const router = createBrowserRouter([
    {
      path: "tests/view/:testId/diagrams/edit/:answerSheetId/:diagramId/:registrationId?/:studentId?/:urltoken?",
      element: <AnswerSheets editMode />,
    },
    {
      path: "*",
      element: <Root />,
      errorElement: <ErrorPage />,
      children:
        blank === false
          ? [
              //? Rotas Públicas
              {
                path: "blank",
                element: <Blank />,
              },
              {
                path: "",
                element: <DashboardView />,
              },
              {
                path: "edit-profile",
                element: <EditProfile />,
              },
              {
                path: "disciplines",
                element: <DisciplinesView />,
              },
              //! Rotas Protegidas
              {
                element: <ProtectedRoute />,
                children: [
                  {
                    path: "demands",
                    element: <DemandsView />,
                  },
                  {
                    path: "demands/create",
                    element: <DemandForm />,
                  },
                  {
                    path: "demands/edit/:id",
                    element: <DemandForm editMode />,
                  },
                  {
                    path: "demands/:id",
                    element: <DemandsManagerView />,
                  },
                  {
                    path: "demands/:id/create",
                    element: <DemandsManagerForm />,
                  },
                  {
                    path: "demands/:id/edit/:idAttribute",
                    element: <DemandsManagerForm editMode />,
                  },
                  {
                    path: "demands/:id/questions/:idAttribute",
                    element: <QuestionsDemandForm />,
                  },
                  // {
                  //   path: "demands/questions/:id",
                  //   element: <TeacherDemandsManagerQuestions withAdmin />,
                  // },
                  {
                    path: "disciplines",
                    element: <DisciplinesView />,
                  },
                  {
                    path: "disciplines/create",
                    element: <DisciplinesForm />,
                  },
                  {
                    path: "disciplines/edit/:id",
                    element: <DisciplinesForm editMode />,
                  },
                  {
                    path: "organizations",
                    element: <OrganizationView />,
                  },
                  {
                    path: "questions",
                    element: <QuestionsView />,
                  },
                  // {
                  //   path: "questions/edit/:id",
                  //   element: <QuestionsCreate editMode />,
                  // },
                  {
                    path: "public-questions",
                    element: <QuestionsPublicView />,
                  },
                  {
                    path: "public-questions/edit/:id",
                    element: <QuestionsPublicEdit />,
                  },
                  {
                    path: "questions/create",
                    element: <QuestionsForm />,
                  },
                  {
                    path: "questions/edit/:id",
                    element: <QuestionsForm editMode />,
                  },
                  {
                    path: "questions/create/ai",
                    //element: <QuestionsCreateAI />,
                  },
                  {
                    path: "organizations/create",
                    element: <OrganizationForm />,
                  },
                  {
                    path: "organizations/edit/:id",
                    element: <OrganizationForm editMode />,
                  },
                  {
                    path: "users-admin",
                    element: <UsersAdminView />,
                  },
                  {
                    path: "users-admin/create",
                    element: <UsersAdminForm />,
                  },
                  {
                    path: "users-admin/edit/:id",
                    element: <UsersAdminForm editMode />,
                  },
                  {
                    path: "users-collaborator",
                    element: <UsersCollaboratorView />,
                  },
                  {
                    path: "users-collaborator/permissions/:id",
                    element: <PermessionForm />,
                  },
                  {
                    path: "users-collaborator/create",
                    element: <UsersCollaboratorForm />,
                  },
                  {
                    path: "users-collaborator/edit/:id",
                    element: <UsersCollaboratorForm editMode />,
                  },
                  {
                    path: "users-teacher",
                    element: <UsersTeacherView />,
                  },
                  {
                    path: "users-teacher/create",
                    element: <UsersTeacherForm />,
                  },
                  {
                    path: "users-teacher/edit/:id",
                    element: <UsersTeacherForm editMode />,
                  },
                  {
                    path: "users-teacher/permissions/:id",
                    element: <PermessionForm />,
                  },
                  {
                    path: "users-student",
                    element: <UsersStudentView />,
                  },
                  {
                    path: "users-student/create",
                    element: <UsersStudentForm />,
                  },
                  {
                    path: "users-student/edit/:id",
                    element: <UsersStudentForm editMode />,
                  },
                  {
                    path: "permissions/:id",
                    element: <PermessionForm />,
                  },
                  {
                    path: "units",
                    element: <UnitView />,
                  },
                  {
                    path: "units/create",
                    element: <UnitForm />,
                  },
                  {
                    path: "units/edit/:id",
                    element: <UnitForm editMode />,
                  },
                  {
                    path: "units/view/:id",
                    element: <UnitViewDetails />,
                  },
                  {
                    path: "courses",
                    element: <CourseView />,
                  },
                  {
                    path: "courses/create",
                    element: <CourseForm />,
                  },
                  {
                    path: "courses/edit/:id",
                    element: <CourseForm editMode />,
                  },
                  // {
                  //   path: "courses/:id/turmas",
                  //   element: <ClassView />,
                  // },
                  {
                    path: "courses/view/:id",
                    element: <CourseViewDetails />,
                  },
                  {
                    path: "turmas",
                    element: <ClassView />,
                  },
                  {
                    path: "turmas/create",
                    element: <ClassForm />,
                  },
                  {
                    path: "turmas/edit/:id",
                    element: <ClassForm editMode />,
                  },
                  {
                    path: "turmas/view/:id",
                    element: <ClassManager />,
                  },
                  {
                    path: "registrations",
                    element: <RegistrationView />,
                  },
                  {
                    path: "registrations/edit/:id",
                    element: <RegistrationForm />,
                  },
                  // {
                  //   path: "correction-exams",
                  //   element: <CorrectionExamsList />,
                  // },
                  // {
                  //   path: "correction-exams/:id",
                  //   element: <CorrectionExamStudentsList />,
                  // },
                  // {
                  //   path: "correction-exams/:id/student/:idS",
                  //   element: <CorrectionExamStudentQuestionsList />,
                  // },
                  // {
                  //   path: "corrections/edit/:id",
                  //   element: <CorrectionForm editMode />,
                  // },
                  // {
                  //   path: "logs/",
                  //   element: <LogView />,
                  // },
                  // {
                  //   path: "upload-exam",
                  //   element: <UploadExamView />,
                  // },
                  {
                    path: "usabilidade/texto",
                    element: <Usabilidade />,
                  },
                  {
                    path: "usabilidade/avaliacao",
                    element: <Avaliacao />,
                  },
                  {
                    path: "usabilidade/avaliacao/visibilidade",
                    element: <Visibilidade />,
                  },
                  {
                    path: "usabilidade/avaliacao/correspondecia",
                    element: <Correspondecia />,
                  },
                  {
                    path: "usabilidade/avaliacao/controle",
                    element: <Controle />,
                  },
                  {
                    path: "usabilidade/avaliacao/consistencia",
                    element: <Consistencia />,
                  },
                  {
                    path: "usabilidade/avaliacao/prevencao",
                    element: <Prevencao />, 
                  },
                  {
                    path: "usabilidade/avaliacao/reconhecimento",
                    element: <Reconhecimento />, 
                  },
                  {
                    path: "usabilidade/avaliacao/flexibilidade",
                    element: <Flexibilidade />, 
                  },
                  {
                    path: "usabilidade/avaliacao/design",
                    element: <Design />, 
                  },
                  {
                    path: "usabilidade/avaliacao/ajuda",
                    element: <Ajuda />,
                  },
                  {
                    path: "usabilidade/avaliacao/documentacao",
                    element: <Documentacao />, 
                  },
                  {
                    path: "usabilidade/avaliacao/gestao",
                    element: <Gestao />, 
                  },
                  {
                    path: "usabilidade/avaliacao/uso",
                    element: <Uso />, 
                  },
                  {
                    path: "usabilidade/avaliacao/visualizacao",
                    element: <Visualizacao />,
                  },
                  {
                    path: "usabilidade/avaliacao/adaptabilidade",
                    element: <Adaptabilidade />, 
                  },
                  {
                    path: "usabilidade/avaliacao/apresentacao",
                    element: <Apresentacao />, 
                  },
                  {
                    path: "manutenibilidade/texto",
                    element: <Manutenibilidade />,
                  },
                  {
                    path: "manutenibilidade/avaliacao",
                    element: <AvaliacaoM />,
                  },
                  {
                    path: "manutenibilidade/avaliacao/modularidade",
                    element: <Modularidade />,
                  },
                  {
                    path: "manutenibilidade/avaliacao/documentalidade",
                    element: <Documentalidade />,
                  },
                  {
                    path: "manutenibilidade/avaliacao/disponibilidade",
                    element: <Disponibilidade/>,
                  },
                  {
                    path: "manutenibilidade/avaliacao/modificabilidade",
                    element: <Modificabilidade/>,
                  },
                  {
                    path: "manutenibilidade/avaliacao/testabilidade",
                    element: <Testabilidade/>,
                  },
                  {
                    path: "manutenibilidade/avaliacao/legibilidade",
                    element: <Legibilidade/>,
                  },
                  {
                    path: "tags/",
                    element: <TagsView />,
                  },
                  {
                    path: "tags/create",
                    element: <TagsForm />,
                  },
                  {
                    path: "tags/edit/:id",
                    element: <TagsForm editMode />,
                  },
                  {
                    path: "exams",
                    element: <ExamView />,
                  },
                  {
                    path: "exams/create",
                    element: <ExamForm />,
                  },
                  {
                    path: "exams/edit/:id",
                    element: <ExamForm editMode />,
                  },
                  {
                    path: "tests",
                    element: <ApplicationView />,
                  },
                  {
                    path: "tests/create",
                    element: <ApplicationForm />,
                  },
                  {
                    path: "tests/edit/:id",
                    element: <ApplicationForm editMode />,
                  },
                  {
                    path: "tests/view/:id",
                    element: <ApplicationManagerView />,
                  },
                  {
                    path: "tests/students/:id/create",
                    element: <ApplicationManagerFormStudent />,
                  },
                  {
                    path: "tests/reviewers/:id/create",
                    element: <ApplicationManagerFormReviewers />,
                  },
                  {
                    path: "tests/exam/:id/create",
                    element: <ApplicationManagerExamForm />,
                  },
                  {
                    path: "tests/diagrams/:id/create",
                    element: <ApplicationManagerDiagramForm />,
                  },
                  {
                    path: "tests/view/:testId/diagrams/create/:diagramId/:registrationId?/:studentId?",
                    element: <AnswerSheets />,
                  },
                  {
                    path: "layouts_default_exams",
                    element: <DiagramView />,
                  },
                  {
                    path: "layouts_default_exams/create",
                    element: <CriarDiagramacao />,
                  },
                  {
                    path: "layouts_default_exams/edit/:id",
                    element: <CriarDiagramacao editMode />,
                  },

                  {
                    path: "questionario/visualizar",
                    element: <ModalMensagem />,
                  },

                   {
                    path: "usabilidade/resultados",
                    element: <ModalMensagem />,
                  },
                  {
                    path: "manutenibilidade/resultados",
                    element: <ModalMensagem />,
                  },
                  {
                    path: "resultados/visualizar",
                    element: <ModalMensagem />,
                  },
                ],
              },
              // Rota de Unauthorized
              {
                path: "unauthorized",
                element: <Unauthorized />,
              },
            ]
          : [],
    },
  ]);

  return (
    <div>
      {/* <BrowserRouter>
        <Routes>
          <Route
            path="layouts_exams/view/:id/:class_id"
            element={<LayoutsExamsForm justView />}
          />
        </Routes>
      </BrowserRouter> */}
      <RouterProvider router={router} />
    </div>
  );
}
